import axios from 'axios';
import i18n from '../i18n';

let state = { isReauthing: false, queue: [] };
const subscribers = new Set();

const notify = (event) => {
  subscribers.forEach((cb) => {
    try { cb(event); } catch (_) { /* swallow */ }
  });
};

export const reauthBus = {
  subscribe(cb) {
    subscribers.add(cb);
    return () => subscribers.delete(cb);
  },

  isReauthing() { return state.isReauthing; },

  queueSize() { return state.queue.length; },

  /**
   * Mise en file de la requête échouée.
   * Ouvre le popup au premier appel.
   * @returns Promise - résolue après replay réussi, rejetée sur logout.
   */
  openAndQueue(config) {
    return new Promise((resolve, reject) => {
      state.queue.push({ config, resolve, reject });
      if (!state.isReauthing) {
        state.isReauthing = true;
        notify({ type: 'open' });
      }
    });
  },

  /**
   * Ouvre la fenêtre SANS rien mettre en file.
   *
   * Le verrou d'inactivité demande le mot de passe alors qu'aucune requête n'a
   * échoué : il n'y a rien à rejouer après la reconnexion. Passer `null` à
   * `openAndQueue` aurait mis `null` dans la file, et `resolveAll` aurait appelé
   * `axios(null)` - une requête inventée, rejetée, dont l'échec serait remonté à
   * l'utilisateur comme si son mot de passe était faux.
   *
   * Sans effet si la fenêtre est déjà ouverte : un 401 et le verrou peuvent
   * tomber ensemble, et c'est la même fenêtre qui répond aux deux.
   */
  demander() {
    if (state.isReauthing) return;
    state.isReauthing = true;
    notify({ type: 'open' });
  },

  /**
   * Appelée par <ReauthGate> après un refresh réussi (le nouveau token
   * est déjà en sessionStorage, l'intercepteur request l'injectera).
   */
  resolveAll() {
    const pending = state.queue;
    state.queue = [];
    state.isReauthing = false;
    notify({ type: 'close' });
    pending.forEach(({ config, resolve, reject }) => {
      axios(config).then(resolve, reject);
    });
  },

  /**
   * Appelée sur timer 0 ou bouton "Se déconnecter".
   * Rejette toutes les requêtes en attente - l'appelant fera le logout/redirect.
   */
  rejectAllAndLogout() {
    const pending = state.queue;
    state.queue = [];
    state.isReauthing = false;
    notify({ type: 'close' });
    const err = new Error(i18n.t('referentiels:session.terminee'));
    pending.forEach(({ reject }) => reject(err));
  },
};

// Helper de test - ne pas utiliser en runtime.
export const __resetReauthBusForTests = () => {
  state = { isReauthing: false, queue: [] };
  subscribers.clear();
};
